import {
  Box,
  Divider,
  DrawerHeader,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  useBreakpointValue,
  useSteps,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useCreateContractModalContext } from '../modals/CreateContractModal/ModalContext';

const steps = [
  {
    title: 'Tipo',
  },
  {
    title: 'Serviços',
  },
  {
    title: 'Pagamento',
  },
  {
    title: 'Contrato',
  },
];

const ContractModalHeader = () => {
  const { step, loading, setStep } = useCreateContractModalContext();
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });
  const orientation = useBreakpointValue({
    base: 'vertical',
    sm: 'horizontal',
    md: 'horizontal',
  }) as 'vertical' | 'horizontal';

  useEffect(() => {
    setActiveStep(loading ? steps.length - 1 : step);
  }, [step, setActiveStep, loading]);

  return (
    <DrawerHeader>
      Adicionar contrato
      <Divider my="1rem" />
      <Stepper index={activeStep} mt="1.5rem" orientation={orientation}>
        {steps.map((s, idx) => (
          <Step key={s.title}>
            <StepIndicator
              cursor={step > idx ? 'pointer' : 'default'}
              onClick={() => step > idx && setStep(idx)}
            >
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>
            <Box
              flexShrink="0"
              cursor={step > idx ? 'pointer' : 'default'}
              onClick={() => step > idx && setStep(idx)}
            >
              <StepTitle>{s.title}</StepTitle>
            </Box>
            {idx < steps.length - 1 && <StepSeparator />}
          </Step>
        ))}
      </Stepper>
    </DrawerHeader>
  );
};

export default ContractModalHeader;
